import { useEffect } from 'react';
import { useAppErrorHandler } from '../contexts/app-error-handler-provider';
import {
  APP_ERROR_TYPE,
  ERROR_USER_INTERFACE,
} from '../contexts/app-error-handler-provider/types';

/**
 * Component for handling 404 routes.
 * Triggers the AppErrorHandler to show a proper not found page.
 */
export function NotFoundRoute() {
  const { setError } = useAppErrorHandler();

  useEffect(() => {
    setError({
      type: APP_ERROR_TYPE.NOT_FOUND,
      userInterface: ERROR_USER_INTERFACE.PAGE,
    });
  }, [setError]);

  return null;
}
